import React, { useState } from 'react';
import { Card, CardActions, CardContent, CardMedia, Button, Typography, ButtonBase } from '@material-ui/core';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { deletePost, likePost } from '../../../actions/posts';

import useStyles from './styles';
import ThumbUpAltOutlined from '@material-ui/icons/ThumbUpAlt';
import { useHistory } from 'react-router-dom';

const Post = ({ post, setCurrentId }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const { _id, message, name, title, tags, likes: postLikes, createdAt, selectedFile: imageFile } = post;
    const user = JSON.parse(localStorage.getItem('profile'));
    const [likes, setLikes] = useState(postLikes);

    const userId = user?.result.googleId || user?.result?._id;
    const hasLikedPost = postLikes.find((like) => like === userId);

    const handleLikes = async () => {
        dispatch(likePost(_id));
        if(hasLikedPost) {
            setLikes(postLikes.filter((id) => id !== userId));
        } else {
            setLikes([...postLikes, userId]);
        }
    }

    const Likes = () => {
        if(likes.length > 0) {
            return (
                likes.find((like) => like === userId)
            ? (
                <><ThumbUpAltIcon fontSize='small' /> &nbsp; {likes.length > 2 ? `You and ${likes.length - 1} others` : `${likes.length} like${likes.length > 1 ? 's' : ''}`}</>
            ) : (
                <><ThumbUpAltOutlined fontSize='small' /> &nbsp; {likes.length} {likes.length === 1 ? 'Like' : 'Likes'} </>
            )
            )
        }

        return <><ThumbUpAltOutlined fontSize='small' /> &nbsp; Like</>;
    }

    const openPost = () => history.push(`/posts/${post._id}`);

    return (
        <Card className={classes.card} raised elevation={6}>
            {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
                <div className={classes.overlay2}>
                    <Button
                        style={{ color: 'white' }}
                        size="small"
                        onClick={() => {setCurrentId(_id)}}
                        >
                        <MoreHorizIcon fontSize='medium' />
                    </Button>
                </div>
            )}
            <ButtonBase className={classes.cardAction} onClick={openPost} >
                <CardMedia className={classes.media} image={imageFile} title={title} />
                <div className={classes.overlay}>
                    <Typography variant='h6'>{name}</Typography>
                    <Typography variant='body2'>{moment(createdAt).fromNow()}</Typography>
                </div>
                <div className={classes.details}>
                    <Typography variant='body2' color="textSecondary">
                        {tags.map((tag) => {
                            return `#${tag} `
                        })}
                    </Typography>
                </div>
                <Typography className={classes.title} variant="h5" guttorbottom="true">{title}</Typography>
                <CardContent>
                    <Typography variant="body2" color='textSecondary' component='p'>{message}</Typography>
                </CardContent>
            </ButtonBase>
                <CardActions className={classes.cardActions}>
                        <Button size='small' color='primary' disabled={!user?.result} onClick={handleLikes}>
                            <Likes />
                        </Button>
                        {(user?.result?.googleId === post?.creator || user?.result?._id === post?.creator) && (
                            <Button size='small' color='primary' onClick={() => {dispatch(deletePost(_id))}}>
                                <DeleteIcon fontSize='small' /> Delete
                            </Button>
                        )}
                </CardActions>
        </Card>
    )
}

export default Post;